import { useEffect, useState } from 'react';
import { FiPieChart } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import EmptyState from '../../components/ui/EmptyState';
import { getForms } from '../../services/formService';

export default function ReportsView() {
  const [forms, setForms] = useState(null);

  useEffect(() => {
    let active = true;
    getForms().then((data) => {
      if (active) setForms(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DashboardLayout title="Reportes" subtitle="Resultados por formulario">
      <SectionCard title="Formularios">
        {forms === null && <EmptyState icon={<FiPieChart />} title="Cargando reportes…" />}
        {forms?.map((form) => {
          const approvalRate = form.totalSubmissions
            ? Math.round((form.approvedCount / form.totalSubmissions) * 100)
            : 0;
          return (
            <div className="report-card" key={form.id}>
              <div className="report-card__header">
                <span className="report-card__title">{form.title}</span>
                <span className="report-card__total">{form.totalSubmissions} registros</span>
              </div>
              <div className="progress-track">
                <div className="progress-fill" style={{ width: `${approvalRate}%` }} />
              </div>
              <div className="report-card__legend">
                <span><i className="dot dot--success" />{form.approvedCount} aprobados</span>
                <span><i className="dot dot--warning" />{form.pendingCount} pendientes</span>
                <span><i className="dot dot--danger" />{form.rejectedCount} rechazados</span>
              </div>
            </div>
          );
        })}
      </SectionCard>
    </DashboardLayout>
  );
}
